import { mapQuery } from 'utils/query';
import { Details } from 'components/details';
import { useGetExpenseQuery } from 'store/api/accounting';
import { BackCategoryButton } from 'components/back-category-button';
import { AccountingExpensesDetails } from 'components/accounting-expenses-details';

import { ExpenseDetailsProps } from './types';

export const ExpenseDetails = ({
  onClose,
  selectedExpenseId,
}: ExpenseDetailsProps) => {
  const { data, ...props } = useGetExpenseQuery(String(selectedExpenseId), {
    skip: !selectedExpenseId,
  });

  return (
    <Details {...mapQuery(props)}>
      <BackCategoryButton onClose={onClose} />
      <AccountingExpensesDetails
        hideEdit
        data={data}
        disableSticky
        hideBackButton
      />
    </Details>
  );
};
